import SyncingIndicator from './syncing-indicator';
export default SyncingIndicator;
